import { render, staticRenderFns } from "./SeleccionPuesto.vue?vue&type=template&id=0421c78c&scoped=true"
import script from "./SeleccionPuesto.vue?vue&type=script&lang=js"
export * from "./SeleccionPuesto.vue?vue&type=script&lang=js"
import style0 from "./SeleccionPuesto.vue?vue&type=style&index=0&id=0421c78c&prod&scoped=true&lang=css"
import style1 from "./SeleccionPuesto.vue?vue&type=style&index=1&id=0421c78c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421c78c",
  null
  
)

export default component.exports